module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', {
    staticClass: "nav-plano"
  }, [_c('li', [_c('label', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.file.label))]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "disabled": _vm.locked
    },
    on: {
      "click": function($event) {
        _vm.$emit('save');
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.file.save))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('saveAs');
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.file.saveAs))]), _vm._v(" "), (_vm.hasAccessCreate('template_builder')) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('saveAsTemplate');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$trad.plano.editor.header.file.saveAsTemplate) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.plano) ? _c('li', {
    attrs: {
      "disabled": _vm.locked
    },
    on: {
      "click": function($event) {
        _vm.showEditNameModal = true;
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$trad.plano.editor.header.file.renamePlanogram.labelMenu) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.file.exit))])])]), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.export.label))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('exportPdf');
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.export.exportPdf))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('exportXls');
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.export.exportExcel))])])]), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.window.label))]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "checked": _vm.showToolbar
    },
    on: {
      "click": function($event) {
        _vm.showToolbar = !_vm.showToolbar;
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.window.toolbar))]), _vm._v(" "), _c('li', {
    attrs: {
      "checked": _vm.showLibrary
    },
    on: {
      "click": function($event) {
        _vm.showLibrary = !_vm.showLibrary;
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.window.library))]), _vm._v(" "), _c('li', {
    attrs: {
      "checked": _vm.showNewbieTool
    },
    on: {
      "click": function($event) {
        _vm.showNewbieTool = !_vm.showNewbieTool;
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.window.dummies))])])]), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.help.label))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.showShortcutsModal = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.help.shortcutList.label))]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.displayInfo
    }
  }, [_vm._v(_vm._s(_vm.$trad.plano.editor.header.help.fileInfo))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.help.help))])])]), _vm._v(" "), _c('li', [_c('LangSelector')], 1)]), _vm._v(" "), (_vm.showShortcutsModal) ? _c('ModalShortcuts', {
    on: {
      "close": function($event) {
        _vm.showShortcutsModal = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditNameModal) ? _c('ModalEditPlanoName', {
    attrs: {
      "plano": _vm.plano
    },
    on: {
      "close": function($event) {
        _vm.showEditNameModal = false;
      },
      "nameChanged": _vm.nameChanged
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b70a9b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/plano-nav.vue
// module id = 3305
// module chunks = 0